import React, { useState } from "react";
import {
  Box,
  TextField,
  FormControl,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../components/Header";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/loadingIndicator";
import { toast } from "react-toastify";
import { addNotificationAction } from "../../redux/actions/notificationAction";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  type: yup.string().required("Type is required"),
  msg: yup.string().required("Message is required"),
});

const Notification = () => {
  const initialFormState = {
    title: "",
    type: "",
    msg: "",
  };
  const [formData, setFormData] = useState(initialFormState);
  const [err, setErr] = useState({});
  const dispatch = useDispatch();
  const adminId = useSelector((state) => state.userStore.user?._id);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      setLoading(true); // Start loading
      const updatedFormData = {
        ...formData,
        adminId: adminId, // Include adminId in the formData
      };

      console.log("Formdata", updatedFormData);
      const response = await dispatch(addNotificationAction(updatedFormData));

      if (response) {
        toast.success("Notification added successufully");
        navigate("/notification");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to add Notification");
      }
    } catch (validationErrors) {
      // Handle validation errors
      const errors = {};
      if (validationErrors.inner) {
        validationErrors.inner.forEach((validationError) => {
          errors[validationError.path] = validationError.message;
        });
      }
      setErr(errors);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
      <Header title="ADD NOTIFICATION" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            onChange={handleChange}
            onBlur={handleBlur}
            value={formData.title}
            margin="normal"
          />{" "}
          {err.title && (
            <Grid item>
              <Typography color="error">{err.title}</Typography>
            </Grid>
          )}{" "}
          {/* TYPE */}
          <TextField
            label="Type"
            name="type"
            onChange={handleChange}
            onBlur={handleBlur}
            value={formData.type}
            margin="normal"
          />{" "}
          {err.type && (
            <Grid item>
              <Typography color="error">{err.type}</Typography>
            </Grid>
          )}{" "}
          {/* MESSAGE */}
          <TextField
            label="Message"
            name="msg"
            onChange={handleChange}
            onBlur={handleBlur}
            value={formData.msg}
            margin="normal"
          />
          {err.msg && (
            <Grid item>
              <Typography color="error">{err.msg}</Typography>
            </Grid>
          )}{" "}
          {/* SUBMIT BUTTON */}
          <Grid container justifyContent="center" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              disabled={loading}
            >
              Submit
            </Button>
          </Grid>
        </FormControl>
      </form>
      {loading && <LoadingIndicator />}
    </Box>
  );
};
export default Notification;
